const getTimeFromVideoStart = (totalTime: number, time: number) => {
  return time < 0 ? totalTime + time : time;
};

export const ScenarioTimeHelper = {
  getTimeFromVideoStart,
};
